import React from 'react';

import { formatTimer } from '../config/constants';

export default ({ cups, quantities, details, onClick }) => (
  <div className="details">
    <div className="details--card">
      <div className="row">
        <div className="col details--card-container">
          <div className="details--card--detail">
            <div className="details--card--detail-action">
              <img
                alt=""
                className="img--card"
                src="/images/beans.svg"
              />
              <span className="details--card--detail-action-title">Coffee</span>
              <span className="details--card--detail-action-sub">{quantities[cups - 1].coffee}g</span>
            </div>
          </div>
          <div className="details--card--detail">
            <div className="details--card--detail-action">
              <img
                alt=""
                className="img--card"
                src="/images/water.svg"
              />
              <span className="details--card--detail-action-title">Water</span>
              <span className="details--card--detail-action-sub">{quantities[cups - 1].water}ml</span>
            </div>
          </div>
          <div className="details--card--detail">
            <div className="details--card--detail-action">
              <img
                alt=""
                className="img--card"
                src="/images/temp.svg"
              />
              <span className="details--card--detail-action-title">Temp</span>
              <span className="details--card--detail-action-sub">{quantities[cups - 1].temp}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="details--table">
      <div className="details--table--detail">
        <span className="details--table--detail-title">Roast Level</span>
        <span className="details--table--detail-sub">{details.roastLevel}</span>
      </div>
      <div className="details--table--detail">
        <span className="details--table--detail-title">Brew Method</span>
        <span className="details--table--detail-sub">{details.brewMethod}</span>
      </div>
      <div className="details--table--detail">
        <span className="details--table--detail-title">Grind Range</span>
        <span className="details--table--detail-sub grind--action" onClick={() => onClick('grind', details.grindRange)}>{details.grindRange}</span>
      </div>
      <div className="details--table--detail">
        <span className="details--table--detail-title">Time</span>
        <span className="details--table--detail-time">
          <img
            alt=""
            className="img--clock"
            src="/images/clock.svg"
          />
          {' '}
          {formatTimer(details.time)}
        </span>
      </div>
    </div>
  </div>
);
